import React, { useState, useEffect } from 'react'

import { Card, ErrorBoundary, Span } from 'components'
import { useToggle, useGet } from 'hooks'
import { useForm } from 'react-hook-form'
import { IGetAllJobsResponse } from 'services/GST/Jobs'
import { COLORS, FONTS, FUNCTIONS, SPACING, TYPOGRAPHY } from 'utils'

import { ModalEditJob, TableJobs } from './components'
import { IForm } from './components/types'

const Jobs: React.FC = () => {
  const [modalEditJobs, toggleModalEditJobs] = useToggle()
  const [refreshScreen, toggleRefreshScreen] = useToggle()
  const [isConsult, setIsConsult] = useState<boolean>(false)

  const [job, setJob] = useState<IGetAllJobsResponse | undefined>()
  const methods = useForm<IForm>()
  const { 
    data: tableData,
    refresh: refreshTable
   } = useGet<{}, IGetAllJobsResponse[]>({
    api: 'Read',
    params: {
      ...FUNCTIONS.filterObject(methods.getValues(), Boolean),
    },
    url: 'Job?TxTipoContexto=GST'
   })

  useEffect(() => {
    refreshTable()
  }, [modalEditJobs, refreshScreen])

  return (
    <>
      <Card
        marginLeft={SPACING.spacing20}
        marginRight={SPACING.spacing20}
        marginBottom={SPACING.spacing100}
        padding={SPACING.spacing20}
        boxShadow={`0 0 1em ${COLORS.lightGray}`}
      >
        <Span
          text="JOBS CADASTRADOS"
          fontSize={TYPOGRAPHY.subtitleSize20}
          fontWeight={FONTS.bold}
          marginTop={SPACING.spacing10}
          marginBottom={SPACING.spacing10}
        />
        {tableData && tableData.length > 0 && (
          <ErrorBoundary>
            <TableJobs
              tableData={tableData}
              setJob={setJob}
              toggleModalEditJobs={toggleModalEditJobs}
              toggleRefreshScreen={toggleRefreshScreen}
              setIsConsult={setIsConsult}
            />
          </ErrorBoundary>
        )}
      </Card>
      <ModalEditJob
        job={job}
        showModalJob={modalEditJobs}
        toggleModal={toggleModalEditJobs}
        isConsult={isConsult}
        setIsConsult={setIsConsult}
      />
    </>
  )
}

export default Jobs
